import React from 'react';
import { connect } from 'react-redux';
import { withTranslation } from "react-i18next";
import { confirmAlert } from 'react-confirm-alert';
import { Radio, Tabs } from "antd";
import 'react-confirm-alert/src/react-confirm-alert.css';

import * as types from 'reducer/actionTypes';
import AdapterList from 'components/adapter/list/AdapterList';
import UniAdapter from 'components/adapter/unified/UniAdapter';

class Adapter extends React.Component {
	componentWillMount(){
		this.props.fetchGetUniAdatperActive();
	}
	
	render(){
		const {t} = this.props;

		const adapterTabs = this.props.uniAdapterActive ? 
		[
			{
				label: `Adapter List`,
				key: '1',
				children: <AdapterList/>
			},
			{
				label: `UniAdapter Interface`,
				key: '2',
				children: <UniAdapter/>
			}
		] : 

		[
			{
				label: `Adapter List`,
				key: '1',
				children: <AdapterList/>
			}
		]

		return(
			<>
			
				<h2>{t('ac.text.label.title')}</h2>
				<div className="content_box">
					<Tabs
						defaultActiveKey = '1'
						type = "card"
						size = "large"
						items = {adapterTabs}
						tabBarExtraContent={null} 
					/>
				</div>
			</>
		)
	}
}

// state를 해당 컴포넌트의 props로 연결
const mapStateToProps = (reducers) => {
	return{
		error: reducers.adapter.error,
		adapterRegister: reducers.adapter.adapterRegister,
		uniAdapterActive: reducers.uniAdapter.uniAdapterActive
	}
}

// 컴포넌트의 함수형 poprs를 실행했을때, 지정한 action을 dispatch 하도록 설정
const mapDispatchToProps = (dispatch) => {
	return{
		fetchGetUniAdatperActive: () => {dispatch({type: types.FETCH_GET_UNIADAPTER_ACTIVE_STATUS_REQUEST, key: 'uniAdapterActive'})},
	}
}

export default withTranslation()(connect(mapStateToProps, mapDispatchToProps)(Adapter))